import React from "react";
import styled from "styled-components";

// Styled Components
const Section = styled.section`
  padding: 60px 20px;
  background-color: #fff;
  color: #111;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #111;
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: #555;
  margin-bottom: 30px;
`;

const StepMap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  margin: 0 auto;
  max-width: 900px;
`;

const VerticalLine = styled.div`
  position: absolute;
  width: 4px;
  height: 90%;
  background-color: #ddd;
  left: 50%;
  transform: translateX(-50%);
  z-index: 0;
`;

const StepContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.align === "left" ? "flex-start" : "flex-end")};
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 15px; /* Add curved edges to StepContainer */

  &:hover > div {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgb(88, 199, 192);
    transition: all 0.3s ease;
  }
`;

const StepContent = styled.div`
  background-color: #f9f9f9;
  color: #333;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 15px; /* Match curved edges of StepContainer */
  width: 40%;
  text-align: left;
  ${(props) => (props.align === "left" ? `margin-right: 60px;` : `margin-left: 60px;`)}
  transition: all 0.3s ease;
`;

const StepCircle = styled.div`
  background-color: #ddd;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  z-index: 1;

  /* Add hover effect for StepCircle */
  &:hover {
    background-color: #58c7c0; /* Change circle color */
    box-shadow: 0 4px 8px rgb(88, 199, 192);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
  }
`;

const HowItWorks = () => {
  const steps = [
    {
      title: "AI Analysis",
      content: "Analyzes historical data, demand patterns, and geography.",
    },
    {
      title: "Smart Recommendations",
      content:
        "Optimizes what inventory to place, in which micro-hubs, and in what quantities.",
    },
    {
      title: "Seamless Execution",
      content:
        "Updates inventory placement in real-time for hyperlocal delivery readiness.",
    },
    {
      title: "Continuous Improvement",
      content:
        "Machine learning is used to improve accuracy and efficiency as you grow.",
    },
  ];

  return (
    <Section id="Howitworks">
      <Title>How It Works</Title>
      <Subtitle>
        Understand how our AI-powered solution transforms your inventory
        management
      </Subtitle>
      <StepMap>
        <VerticalLine />
        {steps.map((step, index) => (
          <StepContainer key={index} align={index % 2 === 0 ? "left" : "right"}>
            {index % 2 === 0 && (
              <StepContent align="left">
                <h3>{step.title}</h3>
                <p>{step.content}</p>
              </StepContent>
            )}
            <StepCircle />
            {index % 2 !== 0 && (
              <StepContent align="right">
                <h3>{step.title}</h3>
                <p>{step.content}</p>
              </StepContent>
            )}
          </StepContainer>
        ))}
      </StepMap>
    </Section>
  );
};

export default HowItWorks;
